import analytics from "web/script/analytics/analytics";
import baustein from "baustein";
import { svgIcon } from "web/script/modules/jinja-filters";
import template from "templates/components/instant-notification";


export default baustein.register("instant-notification", {
    template,

    tagName: "div",

    defaultOptions: {
        hideAfter: 5000,
        icon: "",
        message: "",
        category: "",
    },

    setupEvents(add) {
        add("click", ".instant-notification__close", this.dismiss);
    },

    getInitialRenderContext() {
        return {
            icon: svgIcon(this.options.icon),
            message: this.options.message,
        };
    },

    onInsert() {
        analytics.event(this.options.category, "shown", null, true);
        this.timeout = setTimeout(() => {
            analytics.event(this.options.category, "AutoHide", null, true).then(() => {
                this.destroy();
            });
        }, this.options.hideAfter);
    },

    onRemove() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    },

    dismiss() {
        analytics.event(this.options.category, "Clicked", "Close").then(() => {
            this.destroy();
        });
    },
});
